import { createSlice } from '@reduxjs/toolkit';
//import { AppThunk, AppThunkDispatcher, RootState } from './index';
import { RootState } from './index';

//const LOADER_KEY = 'loader';

const initialState = {
    loaderStatus: false,
    withdrawalStatus: false,
    modalLoaderStatus: false
};

const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        setLoaderStatus: (state, action) => {
            state.loaderStatus = action.payload;
        },
        setWithdrawalStatus: (state, action) => {
            state.withdrawalStatus = action.payload;
        },
        setModalLoaderStatus: (state, action) => {
            state.modalLoaderStatus = action.payload;
        },
    }
});

export const getLoaderSatus = (state: RootState) => state.loader.loaderStatus
export const getWithdrawalStatus = (state: RootState) => state.loader.withdrawalStatus
export const getModalLoaderStatus = (state: RootState) => state.loader.modalLoaderStatus

// EXPORT DEFAULT
export const { setLoaderStatus, setWithdrawalStatus, setModalLoaderStatus } = loaderSlice.actions
export default loaderSlice.reducer;